import React, { Component } from 'react';
import { withStateHandlers, withHandlers, compose, lifecycle, branch, renderComponent } from 'recompose';
import PropTypes from 'prop-types';
import config from '../../config';
import { HTMLTrans } from './Translations';

const Spinner = props => (
  <div className="spinner">
    <div className='pb-spinner pb-fixed' style={{
      background: `url(${config.s3BucketUrl}/assets/general/preloader.gif) no-repeat center center`
    }}/>
    <span className="sr-only"><HTMLTrans id="navbar.common_spinner_loading">Loading...</HTMLTrans></span>
  </div>
);

export const hasSpinner = (WrappedComp) => {
  return class HasSpinner extends Component {
    constructor(props) {
      super(props);
      this.showSpinner = this.showSpinner.bind(this);
    }

    state = {
      isLoading: false
    }

    showSpinner(f) {
      this.setState({ isLoading: true });
      f.promise().always(() => {
        this.setState({ isLoading: false });
      });
    }

    showSpinnerManually = status => {
      this.setState({ isLoading: status });
    }

    render() {
      return (
        <div>
          {this.state.isLoading && <Spinner/>}
          <WrappedComp showSpinnerManually={this.showSpinnerManually} showSpinner={this.showSpinner} {...this.props}/>
        </div>
      );
    }
  };
};

const withSpinnerOverlay = WrappedComponent => ({ loading = false, load, done, ...props }) => {
  // IMPORTANT: React will render whole tree if parent is different, in this case <span>
  return (
    <span>
      {loading && <Spinner/>}
      <WrappedComponent {...props}/>
    </span>
  );
}

export const withSpinnerOnAjax = (functionName, ajaxCall) => compose(
  withStateHandlers({ loading: false }, {
    load: () => () => ({ loading: true }),
    done: () => () => ({ loading: false })
  }),
  withHandlers({
    [functionName]: ({ load, done }) => (...args) => {
      load();
      return ajaxCall(...args).promise().always((data) => {
        done();
        return data;
      });
    }
  }),
  withSpinnerOverlay,
);

export const withSpinnerOnPromise = (functionName, promiseCall) => compose(
  withStateHandlers({ loading: false }, {
    load: () => () => ({ loading: true }),
    done: () => () => ({ loading: false })
  }),
  withHandlers({
    [functionName]: ({ load, done }) => (...args) => {
      load();
      return promiseCall(...args).then((data) => {
        done();
        return data;
      })
    }
  }),
  withSpinnerOverlay,
);

const isLoading = ({ loading }) => loading;
export const withSpinnerWhileLoading = branch(
  isLoading,
  renderComponent(Spinner)
);

export const withFetchOnMount = fetchData => (WrappedComponent) => {
  const withData = lifecycle({
    state: { loading: true },
    componentDidMount() {
      fetchData().then(data =>
        this.setState({ loading: false, data }));
    }
  });
  return compose(
    withData,
    withSpinnerWhileLoading
  )(WrappedComponent);
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/Common/Spinner.js